import { Controller } from "@hotwired/stimulus"

import { addClass, removeClass } from "../src/dom"

const DISABLE_CSS_CLASS = "d-none"

export default class extends Controller {
  static targets = ["target", "trigger"]

  // Lifecycle

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) { return }

    this.setInitialState()
  }

  // Events

  toggleState(event) {
    const element = event.currentTarget
    const selector = element.dataset.toggleSelector
    if (!selector) { return }

    if (!event.skipDisabling) { this.disableAll() }

    if (element.checked) {
      document.querySelectorAll(selector).forEach(el => removeClass(el, DISABLE_CSS_CLASS))
    }
  }

  // Actions

  disableAll() {
    this.targetTargets.forEach(el => addClass(el, DISABLE_CSS_CLASS))
  }

  setInitialState() {
    this.disableAll()
    this.triggerTargets.forEach(el => this.toggleState({ currentTarget: el, skipDisabling: true }))
  }
}
